import styled from '@emotion/styled'
import { color, font, size } from '../../styles'

interface Props {
   list: { key: string; value: string | number | null | undefined }[]
   label: string
   className?: string
}

const KeyValueList: React.FC<Props> = ({ list, label, className }) => {
   if (!list || list.length === 0) return null // if value is null or undefined, don't render anything
   return (
      <Holder className={className || ''}>
         <h3 className="title">{label}</h3>
         <ul>
            {list.map((item, index) => (
               <li key={index}>
                  <p className="key">{item.key}</p>
                  <p className="value">{item.value}</p>
               </li>
            ))}
         </ul>
      </Holder>
   )
}

const Holder = styled.div`
   display: flex;
   flex-direction: column;
   gap: 0.8em;
   width: fit-content;
   max-width: 100%;
   border-left: 1px solid ${color.grayLight};

   .title {
      padding: 0em 0.8em;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-transform: capitalize;
      ${font.regular};
      font-size: ${size.m};
   }

   ul {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 0.7em;
      z-index: 3;
      padding: 0;
      margin: 0;
      margin-left: -15px;

      p {
         margin: 0;
         padding-left: 2.4em;
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
      }

      li {
         display: flex;
         flex-direction: column;
         width: 100%;
         border-radius: 0.5em;

         .key {
            font-size: ${size.s};
            color: ${color.grayDark};
            ${font.regular};
            position: relative;

            &:before {
               content: '';
               position: absolute;
               z-index: 0;
               top: 2px;
               left: 7px;
               width: 15px;
               border-radius: 50%;
               aspect-ratio: 1;
               z-index: 2;
               background-color: var(--holder-background-color, ${color.white});
               mix-blend-mode: difference;
            }

            &:after {
               content: '';
               position: absolute;
               top: 6px;
               left: 11px;
               width: 7px;
               border-radius: 50%;
               aspect-ratio: 1;
               z-index: 2;
               background-color: #999999;
            }
         }

         .value {
            font-size: ${size.xs};
            color: ${color.grayLight};
            padding-left: 2.9em;
            ${font.thin};
         }
      }
   }
`

export default KeyValueList
